<template>
    <div id="childAccount">
        <div class="title_style">子账号管理</div>
        <div class="divider"></div>
        <div class="inputStyle">
            <el-input placeholder="请输入登录账号" v-model="input1" clearable class="input_style"></el-input>
            <el-input placeholder="请输入账号姓名" v-model="input2" clearable class="input_style input_style2"></el-input>
            <el-input placeholder="请输入手机号码" v-model="input3" clearable class="input_style"></el-input>
            <el-tooltip class="item" effect="dark" content="查询" placement="top"><span  @click="getAccountInfo(); returnPage" class="search-btn"></span></el-tooltip>
            <el-tooltip class="item" effect="dark" content="重置" placement="top"><span  @click="resetBut" class="reset-btn"></span></el-tooltip>
            <el-button class="btnNew btnAll button_style" style="margin-right: 20px" @click="dialogVisible = true" v-if="$_auth('user_add')">创建子账号</el-button>
            <el-button class="btnNew btnAll button_style" :disabled="isDisable" style="margin-right: 10px" @click="batchPasswordBut" v-if="$_auth('user_reset_pwd')">批量重置密码</el-button>
        </div>
        <div>
            <template>
                <el-table ref="multipleTable" :data="tableData" class="tableV1 c-table" @selection-change="handleSelectionChange" header-cell-class-name="getRowClass" tooltip-effect="light">
                    <el-table-column type="selection" width="55" align="center"></el-table-column>
                    <el-table-column prop="loginName" label="登录账号" align="center" min-width="120px" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="realName" label="账号姓名" align="center" min-width="120px" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="mobile" label="手机" align="center" min-width="120px" show-overflow-tooltip></el-table-column>
                    <el-table-column label="状态" min-width="120" show-overflow-tooltip align="center">
                        <template slot-scope="scope">
                            <span v-if="scope.row.status == 0">停用</span>
                            <span v-if="scope.row.status == 1">启用</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="创建时间" min-width="120" show-overflow-tooltip align="center">
                        <template slot-scope="scope">
                            <span>{{scope.row.createTime | formatDate}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="roleName" label="角色" align="center" min-width="100px"
                                     show-overflow-tooltip></el-table-column>
                    <el-table-column label="操作" width="70" align='center' fixed="right">
                        <template slot-scope="scope">
                            <el-dropdown :ref="scope.row.id">
                                <span class="iconfont icon-gengduocaozuo gengduocaozuo"></span>
                                <el-dropdown-menu slot="dropdown" class="group-btn">
                                    <el-dropdown-item v-if="$_auth('user_modify')">
                                        <div size="small" v-text="'编辑'" style="color: #1AB394;min-width: 80px" @click="editorBut(scope.row)"></div>
                                    </el-dropdown-item>
                                    <el-dropdown-item v-if="$_auth('user_reset_pwd')">
                                        <div size="small" style="color: #1AB394" @click="resetPasswordBut(scope.row)">重置密码</div>
                                    </el-dropdown-item>
                                    <el-dropdown-item v-if="$_auth('user_change_status')">
                                        <div size="small" style="color: #1AB394" @click="deleteBut(scope.row)" v-if="scope.row.status == 0">启用</div>
                                        <div size="small" style="color: #1AB394" @click="deleteBut(scope.row)" v-if="scope.row.status == 1">停用</div>
                                    </el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </template>
                    </el-table-column>
                </el-table>
                <el-page :size-change="handleSizeChange" :current-change="handleCurrentChange"
                         :page-config="pageConfig"></el-page>
            </template>
        </div>

        <el-dialog title="添加子用户" :visible.sync="dialogVisible" width="560px" @close="closeDialog"
                   :close-on-click-modal="false">
            <div class="dividerTop"></div>
            <div class="dividerDiv">
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="80px">
                    <el-form-item label="园区" prop="value1">
                        <el-select v-model="ruleForm.value1" multiple placeholder="请选择园区" style="width: 336px">
                            <el-option
                                    v-for="item in park"
                                    :key="item.parkId"
                                    :label="item.parkName"
                                    :value="item.parkId">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="登录账号" prop="value2">
                        <el-input v-model="ruleForm.value2" placeholder="请输入登录账号"></el-input>
                    </el-form-item>
                    <el-form-item label="账号姓名" prop="value3">
                        <el-input v-model="ruleForm.value3" autocomplete="off"></el-input>
                    </el-form-item>
                    <input type="password" style="display: none"/>
                    <el-form-item label="初始密码" prop="value4">
                        <el-input v-model="ruleForm.value4" type="text" required onfocus="this.type='password'"
                                  autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="客服手机" prop="value5">
                        <el-input v-model="ruleForm.value5"></el-input>
                    </el-form-item>
                    <el-form-item label="角色" prop="value6">
                        <el-select v-model="ruleForm.value6" clearable placeholder="请选择" style="width: 336px">
                            <el-option
                                    v-for="item in role"
                                    :key="item.id"
                                    :label="item.roleName"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <div class="dividerBottom1"></div>
                    <el-form-item>
                        <el-button class="btnType btnCancel buttonStyle" @click="dialogVisible = false">取 消
                        </el-button>
                        <el-button class="btnNew btnAll" @click="newUser('ruleForm')">确 定</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </el-dialog>
        <!--删除弹框-->
        <el-dialog title="提示" :visible.sync="deleteDialog" class="delClass" width="540px" center :close-on-click-modal="false">
            <div>
                <span>是否{{stateInfo}}</span><span>这个账号: {{loginName}}</span>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button class="btnType btnCancel buttonStyle" @click="deleteDialog = false">取 消</el-button>
                <el-button class="btnNew btnAll" @click="isAccount">确 定</el-button>
            </span>
        </el-dialog>
        <!--重置密码弹框-->
        <el-dialog title="提示" :visible.sync="resetDialog" class="delClass" width="540px" center :close-on-click-modal="false">
            <div><span>{{resetText}}</span></div>
            <span slot="footer" class="dialog-footer">
                <el-button class="btnType btnCancel buttonStyle" @click="resetDialog = false">取 消</el-button>
                <el-button class="btnNew btnAll" @click="resetPassword">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog title="编辑子用户" :visible.sync="dialogVisible1" width="560px" @close="closeDialog"
                   :close-on-click-modal="false">
            <div class="dividerTop"></div>
            <div class="dividerDiv">
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="80px">
                    <el-form-item label="园区" prop="value1">
                        <el-select v-model="ruleForm.value1" multiple placeholder="请选择园区" style="width: 336px">
                            <el-option
                                    v-for="item in park"
                                    :key="item.parkId"
                                    :label="item.parkName"
                                    :value="item.parkId">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="登录账号" prop="value2">
                        <el-input v-model="ruleForm.value2" placeholder="请输入登录账号"></el-input>
                    </el-form-item>
                    <el-form-item label="账号姓名" prop="value3">
                        <el-input v-model="ruleForm.value3" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="客服手机" prop="value5">
                        <el-input v-model="ruleForm.value5"></el-input>
                    </el-form-item>
                    <el-form-item label="角色" prop="value6">
                        <el-select v-model="ruleForm.value6" clearable placeholder="请选择" style="width: 336px">
                            <el-option
                                    v-for="item in role"
                                    :key="item.id"
                                    :label="item.roleName"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
            </div>
            <div class="dividerBottom"></div>
            <div style="text-align: center">
                <el-button class="btnType btnCancel buttonStyle" @click="dialogVisible1 = false">取 消</el-button>
                <el-button class="btnNew btnAll" @click="isEditor('ruleForm')">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import * as access from '../../../config/access.js';
    import API from '../../../fetch/api.js'

    export default {
        name: 'childAccount',
        data() {
            return {
                parkId: access.storage('projectId'),
                parkIds: "",
                pageConfig: {
                    pageSize: 10,
                    total: 0,
                    pageNumber: 1,
                    pageSizes: [10, 20],
                    layout: 'slot,sizes, prev, pager, next, jumper'
                },
                input1: "",
                input2: "",
                input3: "",
                ruleForm: {
                    value1: [],   //园区
                    value2: '',   //登录账号
                    value3: '',   //账号姓名
                    value4: '',   //初始面
                    value5: '',    //客服手机
                    value6: '',    //角色
                },
                rules: {
                    value1: [
                        {required: true, message: '请选择园区', trigger: 'change'}
                    ],
                    value2: [
                        {required: true, message: '请输入登录账号', trigger: 'blur'}
                    ],
                    value3: [
                        {required: true, message: '请输入账号姓名', trigger: 'blur'}
                    ],
                    value4: [
                        {required: true, message: '请输入初始密码', trigger: 'blur'}
                    ],
                    value5: [
                        {required: true, message: '请输入客服手机', trigger: 'blur'},
                        {
                            validator(rule, value, callback) {
                                if (/(^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$)/.test(value)) {
                                    callback()
                                } else {
                                    callback(new Error('请输入正确手机号码!'))
                                }
                            },
                            trigger: 'blur'
                        }
                    ],
                    value6: [
                        {required: true, message: '请选择角色', trigger: 'change'}
                    ]
                },
                dialogVisible: false,
                deleteDialog: false,
                resetDialog: false,
                isDisable: true,
                dialogVisible1: false,
                tableData: [],
                stateInfo: "",
                userNo: "",
                status: "",
                loginName: "",
                park: [],     //园区信息
                role: [],     //角色信息
                resetText: "",   //重置文本
            }
        },
        methods: {
            getAccountInfo() {         //获取账号信息
                const val = {
                    parkId: this.parkId,
                    pageNumber: this.pageConfig.pageNumber,
                    pageSize: this.pageConfig.pageSize,
                    loginName: this.input1,
                    realName: this.input2,
                    mobile: this.input3
                };
                API.http({
                    fullUrl: "/merchant/users/list",
                    params: val,
                    type: "post",
                }).then(res => {
                    this.tableData = res.data.dataList
                    this.pageConfig.total = res.data.total
                })
            },
            handleSizeChange(val) {
                this.pageConfig.pageNumber = 1;
                this.pageConfig.pageSize = val;
                this.getAccountInfo()
            },
            handleCurrentChange(val) {
                this.pageConfig.pageNumber = val;
                this.getAccountInfo()
            },
            deleteBut(item) {    //启用  停用按钮
                this.deleteDialog = true
                this.userNo = item.merchantUserNo
                this.loginName = item.loginName
                if (item.status == 0) {
                    this.stateInfo = '启用'
                    this.status = 1
                } else {
                    this.stateInfo = '停用'
                    this.status = 0
                }
            },
            isAccount() {
                const val = {     //启用/  停用
                    userNo: this.userNo,
                    status: this.status,
                };
                API.http({
                    fullUrl: '/merchant/users/change_status',
                    params: val,
                    type: "post",
                }).then(res => {
                    if (res.code === 200) {
                        this.$notify({
                            title: '成功',
                            message: '修改成功',
                            type: 'success'
                        });
                    } else {
                        this.$notify.error({
                            title: '错误',
                            message: res.message,
                        });
                    }
                    this.userNo = "";
                    this.deleteDialog = false;
                    this.getAccountInfo();
                });
            },
            resetBut() {
                this.input1 = "";
                this.input2 = "";
                this.input3 = "";
                this.getAccountInfo()
                this.returnPage();
            },
            resetPasswordBut(item) {     //重置密码按钮
                this.resetText = "是否重置此用户的密码？"
                this.userNo = item.merchantUserNo;
                this.resetDialog = true
            },
            resetPassword() {     //重置密码
                API.http({
                    fullUrl: '/merchant/users/reset_pass',
                    params: {userNos: this.userNo},
                    type: "post",
                }).then(res => {
                    if (res.code === 200) {
                        this.$notify({
                            title: '成功',
                            message: '修改成功',
                            type: 'success'
                        });
                    } else {
                        this.$notify.error({
                            title: '错误',
                            message: res.message,
                        });
                    }
                    this.userNo = "";
                    this.resetDialog = false;
                    this.getAccountInfo();
                });
            },
            getParkinfo() {    //查询园区
                API.http({
                    fullUrl: '/merchant/park/list',
                    type: "post",
                }).then(res => {
                    if (res.code === 200) {
                        this.park = res.data
                    }
                });
            },
            gitRoleInfo() {    //查询角色
                API.http({
                    fullUrl: '/merchant/role/list',
                    type: "post",
                }).then(res => {
                    if (res.code === 200) {
                        this.role = res.data.dataList
                    }
                });
            },
            newUser(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.parkIds = String(this.ruleForm.value1.join(','));
                        const val = {
                            parkId: this.parkIds,
                            loginName: this.ruleForm.value2,
                            realName: this.ruleForm.value3,
                            password: this.ruleForm.value4,
                            mobile: this.ruleForm.value5,
                            roleId: this.ruleForm.value6,
                        };
                        API.http({
                            fullUrl: '/merchant/users/add',
                            params: val,
                            type: "post",
                        }).then(res => {
                            if (res.code === 200) {
                                this.$notify({
                                    title: '成功',
                                    message: '新增成功',
                                    type: 'success'
                                });
                                this.closeDialog()
                                this.dialogVisible = false;
                            } else {
                                this.$notify.error({
                                    title: '错误',
                                    message: res.message,
                                });
                            }
                            this.getAccountInfo();
                        });
                    } else {
                        return false;
                    }
                });
            },
            batchPasswordBut() {
                this.resetText = "是否重置这些用户的密码？"
                this.resetDialog = true
            },
            handleSelectionChange(selection) {    //表单发生变化的时候触发
                if (selection.length > 0) {
                    this.isDisable = false
                } else {
                    this.isDisable = true
                }
                this.userNo = "";
                let val = [];
                for (let i = 0; i < selection.length; i++) {
                    val.push(selection[i].merchantUserNo)
                }
                this.userNo = val.join(',')
            },
            editorBut(item) {     //编辑按钮
                let parkList = []
                for (let i = 0; i < item.parkList.length; i++) {
                    parkList.push(item.parkList[i].parkId)
                }
                this.userNo = item.merchantUserNo;
                this.ruleForm.value1 = parkList;
                this.ruleForm.value2 = item.loginName;
                this.ruleForm.value3 = item.realName;
                this.ruleForm.value5 = item.mobile;
                this.ruleForm.value6 = item.roleId;
                this.dialogVisible1 = true
            },
            isEditor(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.parkIds = String(this.ruleForm.value1.join(','));
                        const val = {
                            parkId: this.parkIds,
                            loginName: this.ruleForm.value2,
                            realName: this.ruleForm.value3,
                            mobile: this.ruleForm.value5,
                            roleId: this.ruleForm.value6,
                            userNo: this.userNo,
                        };
                        API.http({
                            fullUrl: '/merchant/users/edit',
                            params: val,
                            type: "post",
                        }).then(res => {
                            if (res.code === 200) {
                                this.$notify({
                                    title: '成功',
                                    message: '编辑成功',
                                    type: 'success'
                                });
                                this.dialogVisible1 = false;
                                this.closeDialog()
                            } else {
                                this.$notify.error({
                                    title: '错误',
                                    message: res.message,
                                });
                            }
                            this.getAccountInfo();
                        });
                    } else {
                        return false;
                    }
                });
            },
            returnPage() {
                this.handleCurrentChange(1)
            },
            closeDialog() {     //清空验证缓存   清空数据缓存
                this.$nextTick(() => {
                    this.$refs.ruleForm.resetFields();
                    this.ruleForm.value1 = [];
                    this.ruleForm.value2 = "";
                    this.ruleForm.value3 = "";
                    this.ruleForm.value4 = "";
                    this.ruleForm.value5 = "";
                    this.ruleForm.value6 = "";
                    this.userNo = "";
                });
            }
        },
        created() {
            this.getParkinfo();
            this.gitRoleInfo();
            this.getAccountInfo();
        }
        ,
        filters: {
            formatDate: function (value) {
                let date = new Date(value);
                let y = date.getFullYear();
                let MM = date.getMonth() + 1;
                MM = MM < 10 ? ('0' + MM) : MM;
                let d = date.getDate();
                d = d < 10 ? ('0' + d) : d;
                let h = date.getHours();
                h = h < 10 ? ('0' + h) : h;
                let m = date.getMinutes();
                m = m < 10 ? ('0' + m) : m;
                let s = date.getSeconds();
                s = s < 10 ? ('0' + s) : s;
                return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
            }
            ,
        }
    }
</script>

<style lang="scss" scoped>
    #childAccount {
        background-color: white;

        .divider {
            width: 100%;
            height: 1px;
            background-color: #E7EAEC;
        }

        .input_style {
            width: 220px;
        }

        .input_style2 {
            margin-left: 10px;
            margin-right: 10px;
        }

        .paging_style {
            color: #606266;
            font-size: 12px;
        }

        .font_style {
            margin-left: 10px;
            font-size: 36px;
            color: #76838E;
            position: relative;
            top: 9px;
        }

        .title_style {
            font-size: 18px;
            color: #1AB394;
            font-weight: 500;
            padding: 10px 0 10px 20px;
        }

        .button_style {
            position: relative;
            top: 14px;
            float: right;
            height: 36px;
            color: white
        }

        .buttonStyle{
            width: 100px;
        }

        .tableStyle {
            width: 100%;
            margin-bottom: 10px;
        }

        .gengduocaozuo {
            color: #BFC4C7;
            font-size: 14px;
        }

        .dividerTop{
            width: 560px;height: 10px;
            background-color: #f2f5fa;
            margin: -20px 0 30px -20px
        }

        .dividerBottom{
            background-color: #f2f5fa;
            margin: 30px 0 20px -20px;
            width: 560px;
            height: 10px;
        }

        .dividerBottom1{
            background-color: #f2f5fa;
            margin: 30px 0 20px -72px;
            width: 560px;
            height: 10px;
        }

        .dividerDiv{
            width: 80%;
            margin-left: 10%
        }

        .search-btn{
            position: relative;
            top: 13px;
            left: 5px;
        }

        .reset-btn{
            position: relative;
            top: 13px;
            left: 5px;
        }
    }
</style>


<style lang="scss">
    #childAccount {
        .inputStyle {
            margin: 7px 0 20px 20px;

            .el-input--small .el-input__inner {
                height: 36px;
                line-height: 36px;
            }
        }

        .getRowClass {
            font-size: 14px;
            background-color: #f2f5fa;
            color: #303233;
            font-weight: 600;
        }

        .btnNew.is-disabled {
            background-color: rgba(26, 179, 148, .5);
            border-color: rgba(26, 179, 148, .5);
        }

        .el-input__inner:focus{
            border-color: #1ab394;
        }

        .tableV1{
            margin-top: 0;
        }
    }
</style>
